import {
	type ButtonProps,
	Button as EpicButton,
	EpicB1Typography,
	Tooltip,
	TooltipPosition,
} from "@constellation-academy/epic-ui";
import { ButtonVariantMap } from "./button.consts";
import { ButtonVariant } from "./button.types";

export const Button = ({
	variant = ButtonVariant.Default,
	tooltip,
	position = TooltipPosition.Right,
	...props
}: ButtonProps<ButtonVariant> & { position?: TooltipPosition }) => {
	return (
		<EpicButton
			{...props}
			typography={EpicB1Typography}
			variant={variant}
			variantMap={ButtonVariantMap}
			renderTooltip={({ target }) => (
				<Tooltip target={target} content={tooltip} position={position} />
			)}
		/>
	);
};
